/**
 * Created by pandemio on 10/05/18.
 */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledAlert, Row, Col } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faChild } from '@fortawesome/free-solid-svg-icons';
/** End of Multiple Language imports **/
import SelectorUserPlans from '../selectors/selector-subscriptions';
import SelectorUserPlanClasses from '../selectors/multi-selector-user-plan-classes';
import ApiCalls from '../../custom-classes/api-calls';

/**
 * To handle the child policy
 */
class ModalUserPlan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalUserPlan: false,
            productsSelected: [],
            userPlanExpirationDate: null,
            userPlanSeats: null,
            userPlanStatus: null,
            productsUserPlan: null,
            selectedPlan: null,
            profileId: null,
            transactionMessage: null,
            transactionMessageColor: null,
        };

        this._ismounted = false;
        this.toggle = this.toggle.bind(this);
        this.setPlanIdState = this.setPlanIdState.bind(this);
        this.setSelectedCoursesState = this.setSelectedCoursesState.bind(this);
        this.saveClasses = this.saveClasses.bind(this);
    }

    /**
     * Function when the component was mounted. If mounted, it set its to true
     * The reason of doing this is because we had some problems when received the props without
     * the component being mounted.
     */
    componentDidMount() {
        this._ismounted = true;
    }

    /**
     * Function when the component is going to be unmounted
     */
    componentWillUnmount() {
        this._ismounted = false;
    }
    /**
     * Component will receive props
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){
        if(this._ismounted){
            this.setState({
                productsSelected: nextProps.data.productsSelected, // Set the selected products
                modalUserPlan: nextProps.data.modalUserPlan, // Show, because it means it was called
            },()=>{
                if(nextProps.data.profileId !== null)
                {
                    this.setState({
                        profileId: nextProps.data.profileId
                    })
                }
            });


        }
    }

    /**
     * Set the selected courses state
     * @param field
     */
    setSelectedCoursesState = (field) => (newValue)=>{
        console.log(newValue);
    };

    /**
     * Save the selected products
     * @param field
     */
    setPlanIdState = (field) => (newValue)=>{
        this.setState({selectedPlan: newValue}, ()=>{
            // Call the plan details
            let apiCall = ApiCalls.getUserSubscriptionDetails(newValue.value);
            apiCall.then((returned)=>{

                if(returned.MainAccountPlanDetails.PlanDetailsResponseModelList.length > 0)
                {
                    let plan = returned.MainAccountPlanDetails.PlanDetailsResponseModelList[0];

                    this.setState({
                        userPlanExpirationDate: plan.AgreementEndDate,
                        userPlanSeats: plan.ProfilesQuantity,
                        userPlanStatus: plan.CurrentStatus,
                        productsUserPlan: plan.ProductList
                    });
                }
            });

            this.props.updateParent(this.state);
            return this.state;
        });
    };

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            modalUserPlan: !this.state.modalUserPlan
        },()=>{

            // Reset the other things
            if(this.state.modalUserPlan == false)
            {
                this.setState({
                    transactionMessage: null,
                    transactionMessageColor: null
                })
            }

            this.props.updateParent(this.state);
            return this.state;
        });
    }

    /**
     * Save the user assigned classes in the db
     */
    saveClasses(){
        let apiCall = ApiCalls.insertClassToStudent(this.state.productsSelected, this.state.profileId.value, this.state.selectedPlan.value);
        apiCall.then((returned)=>{
            if(!returned.TransactionValid)
                this.setState({transactionMessageColor: 'danger'});
            else
                this.setState({transactionMessageColor: 'success'});

            this.setState({transactionMessage: returned.Messages[0]});
        });
    }

    /**
     * Renders the alert with message
     * @returns {XML}
     */
    renderAlert(){
        return (
            <UncontrolledAlert color={this.state.transactionMessageColor}>
                { this.state.transactionMessage }
            </UncontrolledAlert>
        );
    }

    /**
     * Renders the plan details. We did it in a separate function to maintain orden, since this is conditional to
     * a plan being selected.
     * @returns {XML}
     */
    renderPlanDetails(){
        return (
            <div>
                <h6><Translate id="assign-seat.choose-plan-classes"/></h6>
                <p><Translate id="assign-seat.plan-details"/> </p>
                    <b><Translate id="assign-seat.expiration-date"/></b> {this.state.userPlanExpirationDate}
                <br/><b><Translate id="assign-seat.plan-seats"/></b> {this.state.userPlanSeats}
                <br/><b><Translate id="assign-seat.status"/></b> {this.state.userPlanStatus}
                <br/><b><Translate id="assign-seat.courses"/></b>
                {
                    this.state.productsUserPlan != null && this.state.productsUserPlan.length > 0 ?
                    <SelectorUserPlanClasses data={this.state} updateParent={this.setSelectedCoursesState}/> :
                    null
                }
            </div>
        )
    }

    /**
     * Renders the component
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <Modal isOpen={this.state.modalUserPlan} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                            <FontAwesomeIcon icon={faChild}/> {' '}
                            <Translate id="assign-seat.assign-seat"/>
                    </ModalHeader>
                    <ModalBody>
                        <h6><Translate id="assign-seat.choose-plan-user"/></h6>
                        <SelectorUserPlans data={this.state} updateParent={this.setPlanIdState()}/>
                        <hr/>
                        {this.state.selectedPlan != null ? this.renderPlanDetails(): null}
                        <Row>
                            <Col sm={{size: 12, offset: 0}} md={{size: 12}} lg={{size: 12}}>
                                {this.state.transactionMessage != null ? this.renderAlert(): null}
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                                <Button onClick={this.saveClasses} color="info">
                                    <Translate id="assign-seat.assign-seat-btn"/>
                                </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
export default ModalUserPlan;


// WEBPACK FOOTER //
// ./src/components/modals/modal-user-plans.js